import { createFileRoute } from '@tanstack/react-router';

import { getCitationOptions } from '@/module/Author/Citation/model/CitationQuery';

export const Route = createFileRoute(
  '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId/_layout',
)({
  loader: async ({ params: { proceedingId, citationId }, context: { queryClient } }) => {
    const citation = await queryClient.ensureQueryData(getCitationOptions(proceedingId, citationId));
    return {
      citation,
      breadcrumb: citation?.title ?? '',
    };
  },
});
